import { createTheme } from '@mui/material/styles';
import { defaultTheme } from './src/theme'

export const theme = createTheme(defaultTheme)